const fallbackMessage = "Unable to mark item as served. Please try again.";
const layersOf = (response) => [response?.data, response?.data?.data, response?.data?.data?.data].filter(Boolean);

export const getConfirmedServedProduct = (response, cartId, cartProductId, variantId) => {
  const layers = layersOf(response);
  const failure = layers.find((value) => Number(value?.es) > 0 || value?.success === false ||
    Number(value?.statusCode) >= 400 ||
    ["ERROR", "FAILED", "FAILURE"].includes(String(value?.status || "").toUpperCase()));
  if (failure || Number(response?.status) >= 400) {
    throw new Error(typeof failure?.message === "string" ? failure.message : fallbackMessage);
  }
  const cart = layers.find((value) => Array.isArray(value?.cartProducts));
  const product = cart?.cartProducts?.find((item) => String(item?.cartProductId) === String(cartProductId));
  if (String(cart?.cartId) !== String(cartId) || String(product?.variantId) !== String(variantId) ||
    product?.productStatus !== "SERVED") {
    throw new Error("The item was not confirmed as served. Please refresh its status before retrying.");
  }
  return product;
};

export const getServeError = (error) => {
  const message = layersOf(error?.response).reverse().find((value) => typeof value?.message === "string")?.message;
  return message || error?.message || fallbackMessage;
};
